<template>
  <div class="container">
    <div class="title">
      {{ status ? title : 'อยู่ระหว่างการปิดปรับปรุง' }}
    </div>
    <div class="counter">
      เวลาก่อนออกผล {{ countdown | formatTime }}
    </div>
    <div class="result">
      <div
        v-for="i in 6"
        :key="i"
        :class="`result-item ${resultDigits[i - 1] ? 'flipped' : ''}`">
        <div class="result-item-number">
          {{ resultDigits[i - 1] }}
        </div>
        <div class="result-item-icon"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'SpaceLottoResult',
  data() {
    return {
      title: '',
      countdown: 0,
      resultDigits: [],
      status: false,
    };
  },
  filters: {
    formatTime(value) {
      const minute = Math.floor(value / 60);
      const seconds = value - (minute * 60);
      if (value < 0) {
        return '00:00'
      }
      return `${String(minute).length > 1 ? minute : `0${minute}`}:${String(seconds).length > 1 ? seconds : `0${seconds}`}`;
    },
  },
  async created() {
    await this.getCurrentPeriod();
    const spaceLottoChannel = pusher.subscribe('presence-space-lotto')
    spaceLottoChannel.bind('result', ({ result }) => {
      const resultToArray = String(result).split('');
      resultToArray.forEach(digit => {
        setTimeout(() => {
          this.resultDigits.push(digit);
        });
      }, 1000)
    });
    spaceLottoChannel.bind('start-new-round', ({ data }) => {
      const currentTime = data.currentTime;
      const endTime = new Date(data.close_date).valueOf();
      const duration = this.findDuration(currentTime, endTime);
      setTimeout(() => {
        this.title = data.period_title;
        this.resultDigits = [];
        this.countdown = Math.round(duration / 1000) - 10;
        this.startCounter();
      }, 10000);
    });
  },
  methods: {
    findDuration(start, end) {
      const currentTime = start;
      const endTime = end;
      const duration = end - start;
      return duration;
    },
    startCounter() {
      const interval = setInterval(() => {
        const secLeft = this.countdown - 1
        this.countdown = secLeft;
        if (this.countdown <= 0) {
          clearInterval(interval);
        }
      }, 1000)
    },
    async getCurrentPeriod() {
      const { data } = await axios.get('/space-lotto/current');
      if (data) {
        this.title = data.title;
        this.status = true;
        if (data.result) this.resultDigits = [JSON.stringify(data.result.first_win)];
        const currentTime = data.currentTime;
        const endTime = new Date(data.close_date).valueOf();
        const duration = this.findDuration(currentTime, endTime);
        this.countdown = Math.round(duration / 1000);
        this.startCounter();
      }
    }
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 30vh;
  background: url('/assets/imgs/autolotto/space.jpeg');
  background-size: cover;
  border: none;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.result {
  display: flex;
  width: 100%;
  justify-content: space-around;
}
.title, .counter {
  position: absolute;
  color: antiquewhite;
  margin-top: 10px;
  font-size: 1rem;
}
.title {
  top: 0px;
  left: 0px;
  margin-left: 10px;
}
.counter {
  right: 0px;
  bottom: 0px;
  margin-right: 10px;
}
.counter.danger {
  color: red;
}
.result-item {
  width: 108px;
  height: 108px;
  position: relative;
  transition-delay: 0.7;
  transition: transform 1s;
  transform-style: preserve-3d;
}
.result-item.flipped {
  transform: rotateY(180deg);
}
.result-item, .result-item-number, .result-item-icon {
    width: 60px;
    height: 60px;
  }
.result-item-number, .result-item-icon {
  position: absolute;
  backface-visibility: hidden;
}
.result-item-number {
  color: white;
  background-color: #2E4357;
  border-radius: 50%;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotateY(180deg);
}
.result-item-icon {
  background: url('/assets/imgs/autolotto/back.png') no-repeat center;
  background-size: contain;
}
@media only screen and (min-width: 600px) {
  .result-item, .result-item-number, .result-item-icon {
    width: 72px;
    height: 72px;
  }
  .counter, .title {
    font-size: 1.2rem;
  }
}
@media only screen and (min-width: 768px) {
  .container {
    height: 30vh;
  }
  .result-item, .result-item-number, .result-item-icon {
    width: 96px;
    height: 96px;
  }
  .counter, .title {
    font-size: 1.5rem;
  }
}
@media only screen and (min-width: 992px) {
  .container {
    height: 30vh;
  }
  .result-item, .result-item-number, .result-item-icon {
    width: 128px;
    height: 128px;
  }
  .counter, .title {
    font-size: 1.5rem;
  }
}
@media only screen and (min-width: 1200px) {
  .container {
    height: 35vh;
  }
  .result-item, .result-item-number, .result-item-icon {
    width: 108px;
    height: 108px;
  }
  .title {
    font-size: 1.5rem;
  }
  .counter {
    font-size: 1.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/autolotto/pages/Result.vue